<script>
	import SpecColumns from './SpecColumns.svelte'
  export let type = '';
  export let title = '';
  export let showDivider = true;

  import models from './../stores/models';
</script>

<div class="specs-modal__line">
  <span class="specs-modal__line-title d-none d-lg-block">{title}</span>
	<SpecColumns {type} {title} />
</div>
{#if showDivider}
  <hr class="specs-modal__divider {!$models.length ? 'specs-modal__divider_mob-hidden' : ''}">
{/if}

<style lang="scss">
  .specs-modal__line {
		display: flex;
		margin-right: 15px;

		&:last-child {
			padding-bottom: 15px;
			@media (min-width: 576px) {
				padding-bottom: 0;
			}
		}
	}

  .specs-modal__line-title {
		font-weight: 500;
		min-width: 230px;
		max-width: 230px;
		padding-top: 8px;
		padding-bottom: 8px;
	}

  .specs-modal__divider {
		margin-top: 0;
    margin-bottom: 0;
		margin-right: 15px;

		&_mob-hidden {
			display: none;

			@media (min-width: 992px) {
				display: block;
			}
		}

		@media (prefers-color-scheme: dark) {
			border-top: 1px solid #dee2e6;
		}
	}
</style>